/** The active API client. Always the real backend — every feature imports
 *  `apiClient` and stays agnostic to the implementation. */
import type { ApiClient } from './contract';
import { realClient } from './real-client';

export const apiClient: ApiClient = realClient;

export type { ApiClient, AnalyticsQuery } from './contract';
